if (!customElements.get('footer-ele')) {
  class FooterElement extends HTMLElement {
    constructor() {
      super();
      this.initCl();
    }

    initCl() {
      this.collapseButtons = this.querySelectorAll('[collapse-btn]');
      requestAnimationFrame(() => {
        this.initActiveStates();
        this.collapseEvents();
      });
    }

    initActiveStates() {
      this.collapseButtons.forEach((button) => {
        const content = button.parentElement.querySelector('[collapse-content]');
        if (!content) return;

        const isActive = content.classList.contains('active');
        button.setAttribute('aria-expanded', isActive ? 'true' : 'false');

        if (isActive) {
          content.style.setProperty('--max-height', `${content.scrollHeight}px`);
        }
      });
    }

    closeAllSections() {
      this.collapseButtons.forEach((btn) => {
        const content = btn.parentElement.querySelector('[collapse-content]');
        if (!content) return;

        content.style.setProperty('--max-height', '0px');
        content.classList.remove('active');
        btn.classList.remove('active');
        btn.setAttribute('aria-expanded', 'false');
      });
    }

    openSection(button, content) {
      content.style.setProperty('--max-height', `${content.scrollHeight}px`);
      content.classList.add('active');
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
    }

    collapseEvents() {
      this.collapseButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const content = button.parentElement.querySelector('[collapse-content]');
          if (!content) return;

          const isExpanded = content.classList.contains('active');

          if (isExpanded) {
            this.closeAllSections();
          } else {
            this.closeAllSections();
            this.openSection(button, content);
          }
        });
      });
    }
  }

  customElements.define('footer-ele', FooterElement);
}